// Estrae il comune dal dominio o dal path
// Pattern 1 (subdomain): utd-alpignano-to.megtributi.it -> alpignano-to
// Pattern 2 (path, qualsiasi host): /site/vallelunga_bz -> vallelunga-bz
function getMunicipalityFromHostname() {
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;

  // Pattern 1: subdomain utd-{comune}.megtributi.it
  const subdomainMatch = hostname.match(/^utd-(.+)\.megtributi\.it$/);
  if (subdomainMatch) {
    return subdomainMatch[1]; // es. "alpignano-to"
  }

  // Pattern 2: path /site/{comune}, su qualsiasi host.
  // In locale il comune e la provincia si scrivono a mano nell'URL
  // (es. http://localhost:3000/site/marcalloconcasone_mi/), senza vincoli sul valore.
  const pathMatch = pathname.match(/^\/site\/([^\/]+)/);
  if (pathMatch) {
    // Converti underscore in trattini (vallelunga_bz -> vallelunga-bz)
    return pathMatch[1].replace(/_/g, '-');
  }

  // Fallback quando il path non contiene il comune
  return 'vallelunga-bz';
}

// Costruisce l'URL del backend basato sul comune
function getBackendUrl() {
  const municipality = getMunicipalityFromHostname();

  // In sviluppo usa localhost
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return (import.meta.env?.VITE_APP_API_URL_1 || process.env.REACT_APP_API_URL_1 || 'http://localhost:8080') +
           (import.meta.env?.VITE_APP_API_URL_2 || process.env.REACT_APP_API_URL_2 || '/utd/backoffice/v1');
  }

  // In produzione: https://utd-backoffice-{comune}.megtributi.it/utd/backoffice/v1
  return `https://utd-backoffice-${municipality}.megtributi.it/utd/backoffice/v1`;
}

const backendUrl = getBackendUrl();

let route = {
  // auth
  login: '/login/',
  loginSPID: '/login_spid/',
  loginCIE: '/login_cie/',
  // deleghe: elenco dei soggetti per cui si puo' operare e scelta del soggetto
  deleghe: '/deleghe/',
  scegliSoggetto: '/scegli_soggetto/',
  permission: '/permission/',

  // homepage
  homepage: '/homepage/',

  // payments
  payments: '/payments_notice/',

  // paymentsDetail
  paymentsDetail: '/payments/',

  // categories
  categories: '/categories/',

  // availability
  availability: '/availability/',

  // appointments
  appointments: '/appointments/',

  // booking
  booking: '/booking/',

  // videocall appointments
  availability_video: '/availability_video/',
  booking_video: '/booking_video/',

  // modules
  sentsModules: '/forms/',
  sendModule: '/send_form/',
  modules: '/tipi_modulistica/',
  // tipi modulistica online (solo abilitati, con `code`) — endpoint allineato al backend
  // di Gianmaria: v1.py tipo_modulistica_online. Richiede x-access-token.
  tipoModulisticaOnline: '/tipo_modulistica_online/',
  module_detail: '/modulistica/',
  downloadFormAttachment: '/download_form_attachment/',

  // elenco ticket
  ticket: '/tickets/',

  // apertura ticket
  ticketBooking: '/booking_ticket/',

  // messaggi ticket
  messageTicket: '/messages/',

  // rilascia messaggio ticket
  bookingMessageTicket: '/booking_message/',

  // regolations
  regolationsType: "/regulation_types/",
  regolationsDetail: "/regulations/",

  // laws
  lawsType: "/law_types/",
  lawsDetail: "/laws/",

  // richiesta iuv
  bookingIuv: "/booking_iuv/",

  // invio richiesta occupazione suolo pubblico
  requestOccupation: '/request_occupation/',

  // news
  newsHomeList: '/news/',

  //faq
  faqList: '/faq?categoria_id={{id_category}}&pagina',

  // installment
  installment: '/installment/',
  // allegati richiesta rateazione (POST {richiesta_rateazione_id, attachments[]})
  // — endpoint CRUD di Gianmaria: v1.py installment_attachment. Richiede x-access-token.
  installmentAttachment: '/installment_attachment/',

  //dati contribuente
  customer: '/contribuente/'
};
// Converte il comune da trattini a underscore per il parametro API (alpignano-to -> alpignano_to)
function getMunicipalityParam() {
  return getMunicipalityFromHostname().replace(/-/g, '_');
}

for (let i in route) {
  route[i] = backendUrl + route[i] + getMunicipalityParam();
}

// Endpoint esterno pagoPA Checkout (nessuna autenticazione): aggiunto dopo il loop
// perché non va prefissato col backend né col comune.
route.pagoPACheckoutCarts = 'https://api.platform.pagopa.it/checkout/ec/v2/carts';

window.route = route;

window.getMunicipalityString = function () {
  return getMunicipalityParam();
}

window.getMunicipalityStringUrl = function () {
  return getMunicipalityFromHostname();
}

// Base URL per videocall (diverso da backoffice)
window.getVideocallBaseUrl = function () {
  const municipality = getMunicipalityFromHostname();

  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:8080/utd/videocall_room';
  }

  return `https://utd-backoffice-${municipality}.megtributi.it/utd/videocall_room`;
}

export default route;
